import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

import { loadAccountManagerReCaptchaScript, hideAccountManagerReCaptchaBadge } from '../../utils/page';
import useActivePage from '../../hooks/active-page';

const defaultMetadata = {
  keywords: `form, form+, formplus, form builder, online forms, offline forms, mobile forms, registration forms, application forms, form software, data collection, payment forms, surveys, booking forms, nsw-q-xji9hcnh9p-6w7qepqgu1yz0yj7buvdsd2grk-qpg9l0j9qps99533q9s0lq6ew7qophbiduyl6ntgv3hd2vhd4589x895n7t115b2kg7q7-mb3c6kjk2b9u3wxndz`,
  description: `Join over 500k people who have trusted us to create online forms & surveys for all their data collection needs.`
};

const pageMetadata = {
  Auth: {
    keywords: 'online form builder with database, how to forms, create forms, create online registration form database, link form to spreadsheet, google spreadsheet text format, how to edit a form in google docs, web forms software, form, formplus, form builder, online forms, survey, secure forms, mobile friendly, offline forms, save to cloud, mobile forms, form generator, unlimited file uploads, application forms, form software, nsw-q-xji9hcnh9p-6w7qepqgu1yz0yj7buvdsd2grk-qpg9l0j9qps99533q9s0lq6ew7qophbiduyl6ntgv3hd2vhd4589x895n7t115b2kg7q7-mb3c6kjk2b9u3wxndz',
    description: `Sign up to use digital forms that can collect signatures, receive payments, run analytics, team workflows, & lots more. Learn more about Formplus!`
  }
};

const MetaData = ({ children }) => {
  const { title, name } = useActivePage();
  const metadata = pageMetadata[name] ?? defaultMetadata;

  useEffect(() => {
    loadAccountManagerReCaptchaScript(name);
    
    const timeout = setTimeout(() => {
      hideAccountManagerReCaptchaBadge(name);
    }, 500);

    return () => {
      clearTimeout(timeout);
    }
  }, [name]);

  return (
    <>
      <Helmet>
        <title>{title} | Formplus</title>
        <meta name="description" content={metadata.description} />
        <meta name="keywords" content={metadata.keywords} />
      </Helmet>

      {children}
    </>
  );
};

export default MetaData;